// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTab-StyledTab_cls1__o60C8","cls2":"VeloTab-StyledTab_cls2__6uz5V VeloTab-StyledTab_cls1__o60C8"};